import { makeOpgavekompleksetPrintSection } from '@apps/opgavekomplekset';

const printOpgavekompleksetComponentPaper = node => {
  return makeOpgavekompleksetPrintSection(node.component);
};
const opgavekompleksetPaperPrinters = {
  "component-framework.opgavekomplekset": printOpgavekompleksetComponentPaper
};

export { opgavekompleksetPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
